












































import { Vue, Component } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Calendar from '@/modules/calendar/components/Calendar.vue';
import { CalendarFilter } from '@/modules/calendar/store/types';
import VueClipboard from 'vue-clipboard2';
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

@Component({
    name: 'WpShortCodesGenerator',
    components: { Calendar },
})
export default class WpShortCodesGenerator extends Vue {
    @Getter('getCalendarFilters', { namespace: 'calendar' }) private getCalendarFilters!: {
        [key: string]: CalendarFilter;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setHiddenFilters', { namespace: 'calendar' }) private setHiddenFilters: any;

    private selectedAppMode = 'Calendar';

    private selectedHiddenFilters: [] = [];

    private get appModeItems() {
        return [
            { text: 'Grafik zajęć', value: 'Calendar' },
            { text: 'Formularz', value: 'Form' },
            { text: 'Admin', value: 'AdminMode' },
            { text: 'Router', value: 'router-view' },
        ];
    }

    private get hiddenFiltersItems() {
        return [
            { text: 'Prowadzący', value: 'InstructorName' },
            { text: 'Zajęcia', value: 'Name' },
            { text: 'Miejsce', value: 'Address' },
            { text: 'Poziom zaawansowania', value: 'AdvanceLevel' },
            { text: 'Styl', value: 'GroupDanceStyle' },
            { text: 'Forma ruchu', value: 'DanceStyleCategories' },
            { text: 'Status', value: 'StartDate' },
            { text: 'Typ grupy', value: 'GroupType' },
        ];
    }

    private get appMode() {
        return this.selectedAppMode;
    }

    private get hiddenFilters() {
        const hiddenFilters = this.selectedHiddenFilters.map((x: any) => x);
        const hiddenFiltersString = hiddenFilters.join(',');
        return hiddenFiltersString;
    }

    private get selectedFilters() {
        return Object.values(this.getCalendarFilters);
    }

    private get defaultFilters() {
        const currentFilters = this.selectedFilters.filter(x => x.propertyFilters.length > 0);
        const currentFiltersString = encodeURIComponent(JSON.stringify(currentFilters));
        return currentFiltersString;
    }

    private get content() {
        const appModeString = this.appMode;
        const hiddenFiltersString = this.hiddenFilters;
        const defaultFiltersString = this.defaultFilters;
        return `[dance_calendar defaultfilters='${defaultFiltersString}' hiddenFilters='${hiddenFiltersString}' appWindowMode='${appModeString}']`;
    }

    private alertMessage = '';
    private alertVisible = false;
    private onCopy(e: any) {
        this.alertMessage = e.text;
        this.alertVisible = true;
    }
}
